export const timeSeriesOfInvestmentAmountForTrends = {
    copy: 'コピー',
    chartTitle: '世界の直近の投資総額推移',
    chartDescription:
        '投資総額が大きいテーマ上位10件を表示しています。\nテーマが絞り込まれている場合は、絞り込み結果の中で上位10テーマを表示します。',
    themeName: 'テーマ名',
    xAxis: '年',
    yAxis: '投資総額'
}
